/* tslint:disable */
/* eslint-disable */
/**
 * Kundenportal-Rest
 * This is the SAF Kundenportal-Rest API
 *
 * The version of the OpenAPI document: 1.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CourseRegistrationForm,
    CourseRegistrationFormFromJSON,
    CourseRegistrationFormToJSON,
    CourseRegistrationFormPrefills,
    CourseRegistrationFormPrefillsFromJSON,
    CourseRegistrationFormPrefillsToJSON,
} from '../models';

export interface RegisterCourseRequest {
    courseRegistrationForm?: CourseRegistrationForm;
}

/**
 * 
 */
export class CourseApi extends runtime.BaseAPI {

    /**
     */
    async getRegisterCoursePrefillsRaw(): Promise<runtime.ApiResponse<CourseRegistrationFormPrefills>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("oAuth2", ["ROLE_USER", "ROLE_ADMINISTRATOR", "ROLE_SAF"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/api/course/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CourseRegistrationFormPrefillsFromJSON(jsonValue));
    }

    /**
     */
    async getRegisterCoursePrefills(): Promise<CourseRegistrationFormPrefills> {
        const response = await this.getRegisterCoursePrefillsRaw();
        return await response.value();
    }

    /**
     */
    async registerCourseRaw(requestParameters: RegisterCourseRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("oAuth2", ["ROLE_USER", "ROLE_ADMINISTRATOR", "ROLE_SAF"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/api/course/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourseRegistrationFormToJSON(requestParameters.courseRegistrationForm),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async registerCourse(requestParameters: RegisterCourseRequest): Promise<void> {
        await this.registerCourseRaw(requestParameters);
    }

}
